export enum AuthActionType {
    SIGN_IN = 'SIGN_IN',
    SIGN_OUT = 'SIGN_OUT',
    GET_CURRENT_USER = 'GET_CURRENT_USER',
    SUPERVISOR_SIGN_UP = 'SUPERVISOR_SIGN_UP',
    SUPERVISOR_CAPACITY_UPDATE = 'SUPERVISOR_CAPACITY_UPDATE',
    UPDATE_CURRENT_USER_UNREAD_TOPIC_MESSAGES = 'UPDATE_CURRENT_USER_UNREAD_TOPIC_MESSAGES',
}
